export const ICON_SIZE = 16

export const ICON_STROKE_WIDTH = 2

export const COPY_RESET_DELAY = 2000
